/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceResourceBaseFilter {
    getFixupPrototypeFunction() { return ServiceResourceBaseFilter.fixupPrototype; }

    static newInstance(model: Partial<ServiceResourceBaseFilter>): ServiceResourceBaseFilter {
        let obj = Object.assign(new ServiceResourceBaseFilter(), model);
        ServiceResourceBaseFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceResourceBaseFilter>): ServiceResourceBaseFilter {
        if (!model) return null;
        return ServiceResourceBaseFilter.newInstance(<ServiceResourceBaseFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceResourceBaseFilter) {
        if (!obj) return;

        models.ServiceResourceBaseFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceResourceBaseFilter): boolean {
        Object.setPrototypeOf(obj, ServiceResourceBaseFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Filter by service account IDs
     */
    service_account_ids: Array<string>;

    /**
     * Filter by region/location/zone
     */
    location: string;

    /**
     * Resource tags as key-value pairs
     */
    tags: Array<models.KeyValuePair>;

    /**
     * Filter by operation ID
     */
    operation_id: string;

    /**
     * Filter by resource filter, also known as resource group in Azure
     */
    resource_filter: string;

    /**
     * Filter by resource category
     */
    category: string;

    /**
     * Filter by resource component
     */
    component: string;

    /**
     * Filter by tenant IDs
     */
    tenant_ids: Array<string>;

    /**
     * Filter by unique ID of the resource
     */
    check_resource_element: string;

    /**
     * Filter by parent unique ID of the resource
     */
    check_resource_parent_id: string;

}
